function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './GeneralCardIconCards.css';
import React from 'react';
import { canUseDOM, get, getColorByTheme, getPageThemeColors } from '../../utils';
import { useSitecoreContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { DefaultCards } from './components/DefaultCards';
import { StickyCards } from './components/StickyCards';
import { RectangularCards } from './components/RectangularCards';
import { isNil } from '../../utils/IsNil';
import { hexToRgb } from '../../utils/hexToRgb';
export let EGeneralCardsIconTypes = /*#__PURE__*/function (EGeneralCardsIconTypes) {
  EGeneralCardsIconTypes["Default"] = "Default";
  EGeneralCardsIconTypes["Rectangular"] = "Rectangular";
  EGeneralCardsIconTypes["Sticky"] = "Sticky";
  return EGeneralCardsIconTypes;
}({});
export const GeneralCardIconCards = _ref => {
  let {
    fields,
    params
  } = _ref;
  const sitecoreContext = useSitecoreContext();
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const [isVdsite, setIsVdsite] = React.useState(true);
  const isDetSite = get(params, 'RenderingStyle') === 'DDA' || false;
  React.useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  if (!fields) {
    console.info('GeneralCardIconCards component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [GeneralCardIconCards component is empty: please provide data source]");
    }
    return null;
  }
  const cardVariant = get(params, 'variant');
  const isCardBackgroundWhite = get(params, 'isCardBackgroundWhite');
  const BackgroundColorHex = get(params, 'BackgroundColorHex');
  const ActiveColorHex = get(params, 'ActiveColorHex');
  const ColorHex = get(params, 'ColorHex', getColorByTheme(BackgroundColorHex));
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  const selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  const color = BackgroundColorHex ? ColorHex : getColorByTheme(selectedPrimaryColor);
  const variables = BackgroundColorHex ? {
    '--general-card-icon-background-color': isCardBackgroundWhite ? "#fff" : isDetSite ? "#fff" : "#F4F4F4",
    '--general-card-icon-color': BackgroundColorHex,
    '--general-card-icon-color-active': ActiveColorHex,
    '--general-card-icon-theme-text-color': color,
    '--general-card-icon-color-with-opacity': isCardBackgroundWhite ? hexToRgb(BackgroundColorHex).concat(", 0.1") : isDetSite ? hexToRgb(BackgroundColorHex).concat(", 0.1") : hexToRgb("#fff").concat(", 1")
  } : {
    '--general-card-icon-background-color': isCardBackgroundWhite ? "#fff" : isDetSite ? "#fff" : "#F4F4F4",
    '--general-card-icon-color': selectedPrimaryColor,
    '--general-card-icon-theme-text-color': color,
    '--general-card-icon-color-active': primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
    '--general-card-icon-color-with-opacity': isCardBackgroundWhite ? hexToRgb(selectedPrimaryColor).concat(", 0.1") : isDetSite ? hexToRgb(selectedPrimaryColor).concat(", 0.1") : hexToRgb("#fff").concat(", 1")
  };
  const generalCardsIconMap = {
    "Default": /*#__PURE__*/React.createElement(DefaultCards, {
      fields: fields,
      params: params
    }),
    "Rectangular": /*#__PURE__*/React.createElement(RectangularCards, {
      fields: fields,
      params: params
    }),
    "Sticky": /*#__PURE__*/React.createElement(StickyCards, {
      fields: fields,
      params: params
    })
  };
  if (isNil(generalCardsIconMap[cardVariant])) {
    console.warn(`component with "${cardVariant}" variant is not defined, try to use of this options ${Object.values(EGeneralCardsIconTypes)}`);
    return null;
  }
  const componentBackgroundColor = isCardBackgroundWhite ? isDetSite ? "#FBF8FD" : "#F4F4F4" : "#fff";
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    style: _objectSpread(_objectSpread({}, variables), {}, {
      background: componentBackgroundColor
    }),
    isDetSite: isDetSite,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, generalCardsIconMap[cardVariant]);
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl,
    className,
    anchorUrlParameter,
    style,
    isDetSite
  } = _ref2;
  const commonStyles = isDetSite ? "c1qb6w9g" : "c1qr1ocu";
  const ltrStyles = isDetSite ? "lqhntxl" : "l1okai30";
  const rtlStyles = isDetSite ? "r19s02oa" : "r1jkqgor";
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    style: style,
    anchorUrlParameter: anchorUrlParameter,
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles} ${className}`
  }, children);
};
export default GeneralCardIconCards;